import type { Revision, RevisionPage } from '../../types';
import { mutations } from '../../utils';

/**
 * Get the rootPages of the given Revision as an array of RevisionPage entities.
 */
export function getRootPagesInRevision(revision: Revision): RevisionPage[];
export function getRootPagesInRevision(
    revision: mutations.MutableData<Revision>
): mutations.MutableData<RevisionPage>[];
export function getRootPagesInRevision(
    revision: mutations.MutableData<Revision>
): mutations.MutableData<RevisionPage>[] {
    return mutations.map(mutations.get(revision, 'rootPages'), (pageId) => {
        const page = mutations.getIn(revision, ['pages', pageId] as const);
        if (!page) {
            throw new Error(
                `Page ${pageId} not found in revision ${mutations.get(revision, 'id')}`
            );
        }
        return page;
    });
}
